import React from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { useTranslation } from "react-i18next";
import { rewardsEnabled } from "@/lib/rewards";

export default function RewardsCard({ owner = false }) {
    const { t } = useTranslation();
    if (!rewardsEnabled()) return null;
    return <Link to={owner ? "/rewards" : "/field/rewards"} className="flex items-center gap-4 rounded-2xl border border-primary/20 bg-primary/5 p-5 focus-visible:ring-2 focus-visible:ring-primary" data-testid="rewards-dashboard-card">
        <Gift className="h-8 w-8 text-primary" aria-hidden="true" />
        <div><h2 className="font-bold text-lg">{t(owner ? "rewards.control" : "rewards.mine")}</h2>
            <p className="text-sm text-muted-foreground">{t("rewards.independence")}</p></div>
    </Link>;
}
